/**
 * IMPORTS
 */

import { Ban, BookUser, CircleDollarSign, Edit, Trash, TriangleAlert } from "lucide-react";

const dataTitleTableCustomers = [
  { label: "Cliente", accessor: "nome", limit: 60 },
  { label: "Situação", accessor: "situacao", isBadge: true },
  {
    label: "Créditos",
    accessor: "saldo_creditos",
    isBadge: true,
    badgeClassName: "bg-green-500",
  },
  { label: "CNPJ/CPF", accessor: "documento" },
  { label: "Contato", accessor: "contato", limit: 60 },
  { label: "Telefone", accessor: "telefone" },
  { label: "E-mail", accessor: "email", limit: 120 },
  { label: "Consultor", accessor: "consultor" },
];

const dataActionsTableCustomers = [
  {
    icon: Ban,
    label: "Inadiplente",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("Ban", item),
  },
  {
    icon: Trash,
    label: "Excluir",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("Excluir", item),
  },
  {
    icon: Edit,
    label: "Editar",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("Editar", item),
  },
  {
    icon: TriangleAlert,
    label: "Inativos",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("Inativos", item),
  },
  {
    icon: BookUser,
    label: "Modelos",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("modelos", item),
  },
  {
    icon: CircleDollarSign,
    label: "Créditos",
    textColor: "text-red-600",
    onClick: (item: any) => console.log("créditos", item),
  },
];

/**
 * EXPORTS
 */
export { dataActionsTableCustomers, dataTitleTableCustomers };
